// 'Done so far' panel helpers (Mark, 25 Oct 2026). Pure so they can be tested
// without React. The panel only reads /api/chats/{id}/turn-summary; it never
// sends anything to the lane or the agent.

export interface TurnSummaryBody {
  done: string[]
  done_source: 'agent_text' | 'tool_steps' | 'none'
  now: string
  steps: number
}

export interface TurnSummaryResponse {
  active: boolean
  source_message_id?: string
  via?: string | null
  started_at?: number
  next_update_at?: number
  updated_at?: number | null
  summary?: TurnSummaryBody | null
}

export const TURN_SUMMARY_POLL_MS = 60_000

export function turnSummaryPath(chatId: string, topicId: string | null): string {
  const base = `/api/chats/${encodeURIComponent(chatId)}/turn-summary`
  return topicId ? `${base}?topic_id=${encodeURIComponent(topicId)}` : base
}

export function formatClock(epochSeconds: number, timeZone?: string): string {
  return new Intl.DateTimeFormat('en-IE', {
    hour: '2-digit', minute: '2-digit', hour12: false, ...(timeZone ? { timeZone } : {}),
  }).format(new Date(epochSeconds * 1000))
}

export function hoursIn(startedAt: number, nowSeconds: number): string {
  const hours = Math.max(0, nowSeconds - startedAt) / 3600
  return hours < 1 ? `${Math.round(hours * 60)} min` : `${hours.toFixed(1)} h`
}

/** Show a due summary only when it contains progress text for the active turn. */
export function shouldShowPanel(data: TurnSummaryResponse | undefined): boolean {
  if (!data?.active || !data.summary || !data.updated_at) return false
  return data.summary.done.some(item => item.trim().length > 0) || data.summary.now.trim().length > 0
}

export function doneHeading(summary: TurnSummaryBody): string {
  return summary.done_source === 'tool_steps' ? 'Recent steps' : 'Done so far'
}
